import { render, staticRenderFns } from "./Jessibuca.vue?vue&type=template&id=610bdbcd&scoped=true"
import script from "./Jessibuca.vue?vue&type=script&lang=js"
export * from "./Jessibuca.vue?vue&type=script&lang=js"
import style0 from "./Jessibuca.vue?vue&type=style&index=0&id=610bdbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bdbcd",
  null
  
)

export default component.exports